import { render } from "./HelpandSupport.vue?vue&type=template&id=873e8ff6&scoped=true"
import script from "./HelpandSupport.vue?vue&type=script&lang=js"
export * from "./HelpandSupport.vue?vue&type=script&lang=js"

import "./HelpandSupport.vue?vue&type=style&index=0&id=873e8ff6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-873e8ff6"]])

export default __exports__